import { Card, CardProps } from '@blueprintjs/core';
import * as React from 'react';
import {
  Body,
  Icon,
  IconComponentType,
} from 'vet-bones/design-system/components';

interface ProductCardProps extends CardProps {
  description: string;
  label: string;
  logo: IconComponentType;
  link: string;
  testId: string;
}

export const ProductCard: React.VFC<ProductCardProps> = ({
  description,
  label,
  logo,
  link,
  testId,
}) => {
  return (
    <a
      className="sd-product-card"
      data-testid={testId}
      href={link}
      rel="noopener noreferrer"
      target="_blank"
    >
      <Card className="sd-product-card-body" interactive role="button">
        <div className="sd-product-card-header">
          <div className="sd-product-card-icon">
            <Icon IconComponent={logo} size={28} />
          </div>
          <Body size="lg" weight="semibold">
            {label}
          </Body>
        </div>
        <Body className="sd-product-card-description" size="md">
          {description}
        </Body>
      </Card>
    </a>
  );
};
